module.exports = __webpack_public_path__ + "media/images/lb/557-ac278a38e31f5e1c9cc4f1bcd106d503.svg";